import { shallowEqual } from 'react-redux';
import React from 'react';
import usePropsSelector from '../../../../../store/propsStore/usePropsSelector';
import { useApiaComponentContext } from '../../apiaComponent/ApiaComponentContext';
import { useApiaFormContext } from '../../page/ApiaForm';
import IProperty from '../../../../../JSApi/constants/IProperty';
import store from '../../../../../store';
import { DataGridIdentifier } from '../../fields/apiaDataGrid/context';

export default function useFieldLabelPropsSelector() {
  const formProps = useApiaFormContext();
  const fieldProps = useApiaComponentContext();
  const gridIdentifier = React.useContext(DataGridIdentifier);

  const isGridReadonly = React.useMemo(() => {
    if (gridIdentifier?.gridId) {
      return store.getState().dataGridSlice[gridIdentifier.gridId].context.grid
        .field.properties.readonly;
    }
    return false;
  }, [gridIdentifier?.gridId]);

  return usePropsSelector(
    fieldProps.fieldId,
    (props) => {
      return {
        fieldValue: props.value as string,
        type: props.field.fieldType,
        valueType: props.field.valueType,
        isLangs: formProps.formData.langs,
        frmParent: formProps.frmParent,
        isDisabled: props[IProperty.PROPERTY_DISABLED],
        isShowAsText: props[IProperty.PROPERTY_INPUT_AS_TEXT],
        qryId: props.field.qryId,
        isReadonly:
          [
            String(props.readonly),
            String(props.readOnly),
            String(formProps.formData.readOnly),
            String(formProps.formData.readonly),
            String(isGridReadonly),
          ].findIndex(
            (current) =>
              current.toLowerCase() === 'true' || current.toLowerCase() === 't',
          ) !== -1,
      };
    },
    shallowEqual,
  );
}
